import { Button, Spin, Avatar, Tooltip, Popconfirm } from "antd";
import { useState } from "react";
import { DeleteFilled } from "@ant-design/icons";
import { useUserContext } from "../../contexts/UserContext";
import Toast from "../../helpers/Toast";
import { catchError } from "../../services/DaoService";
import { MembreAffaireService } from "../../services/MembreAffaireService";
import PropTypes from "prop-types";
import styles from "./MembreAffaireList.module.scss";

const MembreAffaireList = ({
  paginationData,
  setPaginationData,
  membreAffaires,
  setMembreAffaires,
  searchParams,
  isReadOnly = false,
  canManage = false,
}) => {
  const { check } = useUserContext();
  const [loading, setLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const loadMore = () => {
    if (paginationData?.next_page_url) {
      setLoadingMore(true);
      MembreAffaireService.post(paginationData.next_page_url, searchParams)
        .then((response) => {
          if (!response) return;
          setPaginationData(response.data);
          setMembreAffaires((prev) => [...prev, ...response.data.data]);
        })
        .catch(catchError)
        .finally(() => setLoadingMore(false));
    }
  };

  const handleDelete = (id) => {
    setLoading(true);
    MembreAffaireService.getInstance()
      .remove(id)
      .then((response) => {
        Toast.success(response.message);
        setMembreAffaires((items) => items.filter((item) => item.id !== id));
      })
      .catch(catchError)
      .finally(() => setLoading(false));
  };

  const canDelete = canManage && !isReadOnly;

  return (
    <Spin spinning={loading}>
      <div className={styles.list}>
        {membreAffaires.map((membre) => {
          const user = membre.user;
          return (
            <div key={membre.id} className={styles.row}>
              <div className={styles.rowAvatar}>
                <Avatar size={32} src={user?.avatar}>{user?.name?.[0]}</Avatar>
              </div>
              <div className={styles.rowInfo}>
                <div className={styles.rowName}>{user?.name}</div>
                <div className={styles.rowSub}>
                  <span className={styles.rowEmail}>{user?.email}</span>
                  {user?.personnel?.departement?.nom && (
                    <span className={styles.rowDept}>{user.personnel.departement.nom}</span>
                  )}
                </div>
              </div>
              {canDelete && (
                <div className={styles.rowActions}>
                  <Popconfirm
                    title="Retirer ce collaborateur ?"
                    okText="Retirer"
                    cancelText="Annuler"
                    okType="danger"
                    onConfirm={() => handleDelete(membre.id)}
                  >
                    <Tooltip title="Retirer">
                      <Button
                        type="text"
                        size="small"
                        danger
                        icon={<DeleteFilled />}
                      />
                    </Tooltip>
                  </Popconfirm>
                </div>
              )}
            </div>
          );
        })}
      </div>
      {paginationData?.next_page_url && (
        <div className={styles.loadMore}>
          <Button size="small" onClick={loadMore} loading={loadingMore}>
            Charger plus
          </Button>
        </div>
      )}
    </Spin>
  );
};

export default MembreAffaireList;

MembreAffaireList.propTypes = {
  paginationData: PropTypes.object.isRequired,
  searchParams: PropTypes.object,
  setPaginationData: PropTypes.func.isRequired,
  membreAffaires: PropTypes.array.isRequired,
  setMembreAffaires: PropTypes.func.isRequired,
  isReadOnly: PropTypes.bool,
  canManage: PropTypes.bool,
};
